import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// R-to-3 Welcome Reward CRM — reads the read-only Admin_RTo3_Summary / Admin_RTo3_List procs
// via the Store WebAPI. Same token-refresh pattern as the Ops Review services.
export default class RTo3Service {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getSummary(fromDate, toDate, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_RTO3_SUMMARY });
    let out = {};
    const payload = { fromDate: fromDate || null, toDate: toDate || null };
    await api.endpoints[this.endpoint.GET_RTO3_SUMMARY]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getSummary(fromDate, toDate, true);
      } catch (e) {
        out = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out;
  }

  async getList(filter, search, fromDate, toDate, pageIndex, pageSize, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_RTO3_LIST });
    let out = [];
    const payload = {
      filter: filter || "all",
      search: search || "",
      fromDate: fromDate || null,
      toDate: toDate || null,
      pageIndex: pageIndex || 1,
      pageSize: pageSize || 50,
    };
    await api.endpoints[this.endpoint.GET_RTO3_LIST]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getList(filter, search, fromDate, toDate, pageIndex, pageSize, true);
      } catch (e) {
        out = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out;
  }
}
